import Vue from 'vue';
import axios from 'axios'
import store from '@/store/index'
const _Authorization = 'Authorization',
    _Bearer = 'Bearer ';
let _this = null;
axios.defaults.timeout = 50000;


if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'debug') {
    axios.defaults.baseURL = window.vueConfig.development.apiHost;
    window.hostConfig.webApiHost = window.vueConfig.development.apiHost;
    window.hostConfig.videoHost = window.vueConfig.development.videoHost;
    window.hostConfig.imageHost = window.vueConfig.development.imageHost;

} else if (process.env.NODE_ENV == 'production') {
    axios.defaults.baseURL = window.vueConfig.production.apiHost;
    window.hostConfig.webApiHost = window.vueConfig.production.apiHost;
    window.hostConfig.videoHost = window.vueConfig.production.videoHost;
    window.hostConfig.imageHost = window.vueConfig.production.imageHost;
}

function init(vue) {
    _this = vue;
}

function toAppLogin() {
    console.log('登录失效')
    location.replace("app://toLogin");
}
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
    (res) => {
        let code = res.data.code || '';
        if (code == 401 || code == 202) {
            toAppLogin();
        }
        return Promise.resolve(res);
    },
    (error) => {
        var errorMessage = '';
        if (error.response) {
            let code = error.response.data.code || '';
            if (code == 401 || code == 202) {
                toAppLogin();
            } else if (error.response.status == 404) {
                errorMessage = '没有找到请求地址'
            } else {
                errorMessage = error.response.data.message;
            }
        } else {
            errorMessage = '网络好像出了点问题~'
        }
        if (errorMessage) {
          console.log(errorMessage)
        }
        return Promise.reject(error.response);
    });

function getToken() {
    let token = store.state.token;
    return _Bearer + token;
}
//配置忽略并发Url数组
let urlArr = [];
//防止重复提交字典
let HttpStatusManagerMap = new Map();

function post(url, params, loading, config) {
    // loading = false
    if (url.toLowerCase().includes('add') || url.toLowerCase().includes('update') || url.toLowerCase().includes('del')) {
        if (!urlArr.includes(url)) {
            // 如果已经存在请求的接口，重复请求时，则不进行任何操作了
            let status = HttpStatusManagerMap.get(url);

            if (status) return new Promise((resolve, reject) => { })
        }
        // 将当前请求的url保存起来
        HttpStatusManagerMap.set(url, true);
    }

    // 如果有loading状态，则开启骨架屏
    if (loading) {
        _this.$Bus.$emit('skeletonLoading', loading)
    }
    axios.defaults.headers[_Authorization] = getToken();

    return new Promise((resolve, reject) => {
        axios.post(url, params, config).then(response => {
            if (response.status == 202) {
                HttpStatusManagerMap.delete(url);
                return;
            }
            setTimeout(() => {
                HttpStatusManagerMap.delete(url);
            }, 300)
            resolve(response.data);
        }, err => {
            if (err.status == 202) {
                HttpStatusManagerMap.delete(url);
                return;
            }
            setTimeout(() => {
                HttpStatusManagerMap.delete(url);
            }, 300)
            reject(err)
        }).catch((error) => {
            HttpStatusManagerMap.delete(url);
            reject(error)
        }).finally(() => {
            // 如果有loading状态，关闭骨架屏
            if (loading) {
                _this.$Bus.$emit('skeletonLoading', false)
            }
        })
    })
}

function get(url, param) {
    axios.defaults.headers[_Authorization] = getToken();
    return new Promise((resolve, reject) => {
        axios.get(url, { params: param })
            .then(response => {
                resolve(response.data)
            }, err => {
                reject(err)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export default { post, get, init }


// WEBPACK FOOTER //
// ./src/api/http.js